import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import CollectionsBootstrap from 'modules/posts/lib/NpsCollectionsBootstrap'

const NpsRootPage = () => {
  return (
    <Box flexGrow>
      <CollectionsBootstrap>
        <Outlet />
      </CollectionsBootstrap>
    </Box>
  )
}

export default NpsRootPage
